<section class="account-details__content__owner-type-container">
  <div class="titled-under">
    <p>{{titledUnderLabel}} {{ownerType}}</p>
  </div>
  <div class="change-link" *ngIf="!fromVgTable">
    <p class="c11n-text-md">
      <a c11n-link
         href="javascript:void(0)"
         [variant]="'primary-reinforced'"
         [iconName]="'edit'"
         [iconPosition]="'leading'"
         (click)="handleBack()">{{accountDetailsContent.ACCOUNT_DETAILS_CHANGE}}
      </a>
    </p>
  </div>
</section>

<!-- 5/19/25 Temp Removing I'm Not Sure flow -->
<!--If the ownerType is the "I'm not sure" displayed content, then don't render the dropdown since we don't need to select a user in our current implementation (3/17/2025)-->
<!-- @if (ownerType === AccountOwnerType.NOT_SURE_DISPLAY) {
  <section class="account-details-warning-container">
    <div class="account-details-warning-icon-container">
      <c11n-icon
        name="warning"
        size="small"
        altText="Warning icon for users who don't currently know/remember who the owner of the account they want to add is"
      ></c11n-icon>
    </div>

    <p class="account-details-warning-content">{{accountDetailsContent.ACCOUNT_DETAILS_NOT_SURE_CONTENT}}</p>
  </section>
} @else { -->
<section class="account-details__content__owner-selector-container">
  <!-- New Owner Container Component -->
  <app-account-owner-container
    [accountType]="accountType"
    [selectedAccountOwnerType]="selectedAccountOwnerType"
    [isEditMode]="isEditMode"
    [preselectedOwnerId]="currentAccountOwner"
    [isJointOwnerToggleEnabled]="isJointOwnerToggleEnabled"
    (ownerDataChange)="onOwnerDataChange($event)"
    (validationChange)="onOwnerValidationChange($event)">
  </app-account-owner-container>

</section>
<!-- } -->

<section class="account-details__content__details-container">
  <section class="account-details__content__description" *ngIf="accountType === AccountType.REAL_ESTATE && selectedAccountOwnerType === AccountOwnerType.INDIVIDUAL_BY_NAME">
    {{ ACCOUNT_DETAILS_REQUIRED_FIELDS }}
  </section>

  <div class="account-field-row" *ngIf="accountType !== AccountType.TRUST">
    <div class="account-field">
      <label c11n-label for="account-name-field" [size]="'medium'">{{ accountNameLabel }}</label>
      <c11n-input [size]="'medium'">
        <input
          c11nInput
          [(ngModel)]="accountName"
          [ngModelOptions]="{ updateOn: 'change' }"
          id="account-name-field"
          type="text"
          [placeholder]="accountNamePlaceholder"
          (ngModelChange)="nameInputChangeHandler($event)"
        />
      </c11n-input>
      <c11n-hint-error
        [hasError]="!validAccountNameInput"
        [size]="'medium'"
        [hintText]="ACCOUNT_DETAILS_ACCOUNT_NAME_SUB_TEXT"
        [errorText]="'This field is required'"
        hintErrorId="account-name-error"
      ></c11n-hint-error>
    </div>
    <div class="account-field">
      <label c11n-label for="account-balance-field" [size]="'medium'">{{ localAccountDetailsContent.ACCOUNT_DETAILS_BALANCE }}</label>
      <c11n-input [size]="'medium'">
        <input
          c11nInput
          type="text"
          [(ngModel)]="balance"
          id="account-balance-field"
          [placeholder]="'$'"
          [imask]="InputMask.CURRENCY"
          (ngModelChange)="balanceInputChangeHandler($event)"
        >
      </c11n-input>
      <c11n-hint-error
        [hasError]="!validBalanceInput"
        [size]="'medium'"
        [errorText]="'Please enter a valid balance amount'"
        hintErrorId="account-balance-error"
      ></c11n-hint-error>
    </div>
  </div>
  <div class="account-field-row" *ngIf="showSubAccountType && accountType !== AccountType.TRUST">
    <div class="account-field">
      <c11n-dropdown
        appDropdownTypeahead
        [labelText]="localAccountDetailsContent.ACCOUNT_DETAILS_SUBACCOUNT_TYPE"
        [placeholderText]="ACCOUNT_DETAILS_SUBACCOUNT_PLACEHOLDER"
        [menuData]=subAccountTypeValues
        [activeItems]="currentSubAccountType"
        (stateChange)="subAccountDropdownChangeHandler($event)"
      ></c11n-dropdown>
      <!-- TODO: BINGBONG; 5/14/2025 -> Slice reference error is gone BUT the state values still don't persist between the guided-flow steps/pages; Not only for the dropdowns but the inputs too
      -->
      <c11n-hint-error
        [hasError]="!validSubAccountTypeInput"
        [size]="'medium'"
        [errorText]="'Please make a selection'"
        hintErrorId="account-balance-error"
      ></c11n-hint-error>
    </div>
  </div>
  <div class="account-field-row" *ngIf="accountType === AccountType.REAL_ESTATE">
    <div class="account-field">
      <label c11n-label for="mortgage-balance-field" [size]="'medium'">{{ accountDetailsContent.ACCOUNT_DETAILS_MORTGAGE_AMOUNT }}</label>
      <c11n-input [size]="'medium'">
        <input
          c11nInput
          [(ngModel)]="mortgageAmount"
          id="mortgage-balance-field"
          type="text"
          [placeholder]="'$'"
          [imask]="InputMask.CURRENCY"
          (ngModelChange)="mortgageInputChangeHandler($event)"
        />
      </c11n-input>
      <c11n-hint-error
        [hasError]="!validMortgageInput"
        [size]="'medium'"
        [errorText]="'Please enter a value'"
        hintErrorId="mortgage-balance-error"
      ></c11n-hint-error>
    </div>
  </div>
  <div class="account-field-row" *ngIf="showPod">
    <div class="account-field">
      <c11n-checkbox [labelText]="accountDetailsContent.ACCOUNT_DETAILS_PAYABLE_ON_DEATH"
                     (stateChange)="checkboxChangeHandler($event)">
        <input
          c11nCheckboxInput
          class="c11n-checkbox__input"
          id="pod-checkbox"
          type="checkbox"
          name="pod"
          [checked]="payableOnDeathDesignation"
        />
      </c11n-checkbox>
    </div>
  </div>
</section>

<hr class="account-details__pod-divider" *ngIf="payableOnDeathDesignation && showPod" />

<app-beneficiary-section
  *ngIf="payableOnDeathDesignation && showPod"
  [accountType]="accountType"
  [initialBeneficiaryState]="savedBeneficiaryState"
  (beneficiaryStateChange)="onBeneficiaryStateChange($event)"
  (validationChange)="onBeneficiaryValidationChange($event)"
  (helpClick)="handleHelpClick()"
  #beneficiarySection
></app-beneficiary-section>
